var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "app-dialer-transfer-content" } },
    [
      _vm.tabsWithAgentsTab && _vm.tabsWithAgentsTab.length > 1
        ? _c("app-dialer-tabs", {
            attrs: {
              tabs: _vm.tabsWithAgentsTab,
              "active-tab-id": _vm.activeTabId,
              type: _vm.tabsType,
              size: _vm.size,
            },
            on: {
              "tab-change": function ($event) {
                _vm.activeTabId = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAgentsTab && _vm.activeTabId === _vm.AGENTS_TAB_ID
        ? _c("app-dialer-agent-list", {
            attrs: {
              avatar: _vm.avatar,
              agents: _vm.agents,
              "rule-groups": _vm.ruleGroups,
              size: _vm.size,
              "actions-type": _vm.actionsType,
              "agent-actions-type": _vm.agentActionsType,
              statuses: _vm.statuses,
              "default-search-options": _vm.defaultSearchOptions,
              "can-change-search-options": _vm.canChangeSearchOptions,
              "is-loading": _vm.areAgentsLoading,
              "is-disabled": _vm.areAgentActionsDisabled,
              "can-invite-third-party": _vm.canInviteThirdParty,
            },
            on: {
              "invite-agent": function ($event) {
                return _vm.$emit("invite-agent", $event)
              },
              "invite-3rd-party": function ($event) {
                return _vm.$emit("invite-3rd-party", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeTabId !== _vm.AGENTS_TAB_ID
        ? _c("app-dialer-custom-list", {
            attrs: {
              code: _vm.activeTab ? _vm.activeTab.code : "",
              context: _vm.context,
              size: _vm.size,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }